var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 372,
    viewBox: "0 0 575 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.743 195.164V190.747L288.591 348.937V353.402L562.743 195.164Z",
    fill: "#6D5841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.592 348.985L257.041 330.929L532.94 173.467L562.767 190.722L288.592 348.985Z",
    fill: "#917558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.651 73.9978L442.073 231.46L409.067 249.323L135.886 90.3071L163.651 73.9978Z",
    fill: "#56422E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3923 145.242L320.815 302.705L287.808 320.567L14.6277 161.552L42.3923 145.242Z",
    fill: "#56422E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M284.806 4.90869L563.228 162.371L530.221 180.233L257.041 21.218L284.806 4.90869Z",
    fill: "#56422E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.023 124.097V91.3212L410.35 249.164V282.158L138.023 124.097Z",
    fill: "#433220"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7634 195.342V162.566L289.091 320.409V353.403L16.7634 195.342Z",
    fill: "#433220"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.177 55.0017V22.2256L531.505 180.068V213.062L259.177 55.0017Z",
    fill: "#433220"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442.036 263.481V230.705L410.35 249.164V282.158L442.036 263.481Z",
    fill: "#75593D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M320.777 334.725V301.949L289.091 320.409V353.403L320.777 334.725Z",
    fill: "#75593D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M563.191 194.385V161.609L531.505 180.068V213.062L563.191 194.385Z",
    fill: "#75593D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M563.228 162.194V157.777L289.077 315.967V320.433L563.228 162.194Z",
    fill: "#6D5841"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.077 316.016L257.526 297.959L533.425 140.497L563.253 157.753L289.077 316.016Z",
    fill: "#917558"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M439.682 91.1322V86.7151L165.531 244.905V249.371L439.682 91.1322Z",
    fill: "#6D5841"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.815 22.6429V18.2258L46.6638 176.416V180.882L320.815 22.6429Z",
    fill: "#6D5841"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M360.423 45.7486V41.3315L86.2722 199.522V203.987L360.423 45.7486Z",
    fill: "#6D5841"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M400.032 68.61V64.1929L125.881 222.383V226.849L400.032 68.61Z",
    fill: "#6D5841"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.531 244.954L133.98 226.897L409.879 69.4351L439.706 86.6909L165.531 244.954Z",
    fill: "#917558"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6635 176.465L15.1128 158.408L291.011 0.945801L320.839 18.2016L46.6635 176.465Z",
    fill: "#917558"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2716 199.57L54.7209 181.513L330.62 24.0513L360.447 41.3071L86.2716 199.57Z",
    fill: "#917558"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.881 222.431L94.3301 204.375L370.229 46.9126L400.056 64.1684L125.881 222.431Z",
    fill: "#917558"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M480.808 114.819V110.402L206.657 268.593V273.058L480.808 114.819Z",
    fill: "#6D5841"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.657 268.641L175.106 250.584L451.005 93.1223L480.832 110.378L206.657 268.641Z",
    fill: "#917558"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M522.164 138.507V134.09L248.013 292.28V296.746L522.164 138.507Z",
    fill: "#6D5841"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M248.013 292.328L216.462 274.272L492.361 116.81L522.188 134.065L248.013 292.328Z",
    fill: "#917558"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61149 202.551C0.811328 202.766 0.336617 203.588 0.551188 204.389L4.04782 217.428C4.26239 218.228 5.08499 218.703 5.88515 218.488C6.68531 218.274 7.16002 217.451 6.94545 216.651L3.83733 205.06L15.4278 201.952C16.228 201.738 16.7027 200.915 16.4881 200.115C16.2735 199.315 15.4509 198.84 14.6508 199.055L1.61149 202.551ZM288.843 369.533L288.094 370.833L288.846 371.267L289.597 370.83L288.843 369.533ZM574.95 204.384C575.162 203.583 574.685 202.762 573.884 202.55L560.833 199.097C560.032 198.885 559.211 199.362 558.999 200.163C558.787 200.964 559.265 201.785 560.065 201.997L571.666 205.066L568.597 216.667C568.385 217.468 568.862 218.289 569.663 218.501C570.464 218.713 571.285 218.235 571.497 217.435L574.95 204.384ZM1.25026 205.299L288.094 370.833L289.593 368.234L2.74974 202.701L1.25026 205.299ZM289.597 370.83L574.254 205.297L572.746 202.703L288.089 368.237L289.597 370.83Z",
    fill: "#41B6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.061 313.439C290.475 312.854 289.525 312.854 288.939 313.439L279.393 322.985C278.808 323.571 278.808 324.521 279.393 325.107C279.979 325.692 280.929 325.692 281.515 325.107L290 316.621L298.485 325.107C299.071 325.692 300.021 325.692 300.607 325.107C301.192 324.521 301.192 323.571 300.607 322.985L291.061 313.439ZM291.5 369.5V314.5H288.5V369.5H291.5Z",
    fill: "#41B6E6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallet);
export default __webpack_public_path__ + "static/media/pallet.04552393c6dacf75a0e295de87c455a8.svg";
export { ForwardRef as ReactComponent };